import { Svg } from '../../../components/Svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormsIcon = () => {
  return /*#__PURE__*/_jsxs(Svg, {
    $size: "32px",
    $color: "currentColor",
    $alignWithText: false,
    viewBox: "0 0 32 32",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M9 28H23C24.6533 28 26 26.6533 26 25V7C26 5.34667 24.6533 4 23 4H9C7.34667 4 6 5.34667 6 7V25C6 26.6533 7.34667 28 9 28ZM8 7C8 6.45333 8.45333 6 9 6H23C23.5467 6 24 6.45333 24 7V25C24 25.5467 23.5467 26 23 26H9C8.45333 26 8 25.5467 8 25V7Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 10H21C21.5467 10 22 9.54667 22 9C22 8.45333 21.5467 8 21 8H11C10.4533 8 10 8.45333 10 9C10 9.54667 10.4533 10 11 10Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 14H21C21.5467 14 22 13.5467 22 13C22 12.4533 21.5467 12 21 12H11C10.4533 12 10 12.4533 10 13C10 13.5467 10.4533 14 11 14Z",
      fill: "currentColor"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 18H17C17.5467 18 18 17.5467 18 17C18 16.4533 17.5467 16 17 16H11C10.4533 16 10 16.4533 10 17C10 17.5467 10.4533 18 11 18Z",
      fill: "currentColor"
    })]
  });
};
export default FormsIcon;